import { FrontendRegistration } from "@timeedit/registration-schemas";
import { Mapping } from "@timeedit/registration-shared";
import { Typography } from "@timeedit/ui-components";
import { LoadActions, RegistrationRequiredTranslations } from "../../types";
import { EventModalContentProps } from "./GroupModalContent";
import { createActivityEvents } from "./helpers";
import { ListView } from "../CalendarListView/ScheduleListView";

type ScheduleModalContentProps = {
  translations: RegistrationRequiredTranslations;
  mapping: Mapping;
  registration: FrontendRegistration;
  loadActions: LoadActions;
};
type CreateScheduleModalContentReturn = ({
  eventsWithRelated,
}: EventModalContentProps) => React.JSX.Element;
export function createScheduleModalContent({
  mapping,
  registration,
  translations,
  loadActions,
}: ScheduleModalContentProps): CreateScheduleModalContentReturn {
  const ScheduleModalContent = ({
    eventsWithRelated,
  }: EventModalContentProps) => {
    if (eventsWithRelated.length === 0) {
      return <Typography.Text>404</Typography.Text>;
    }

    const activityEvents = createActivityEvents({ eventsWithRelated });

    return (
      <ListView
        loadActions={loadActions}
        events={activityEvents}
        mapping={mapping}
        registration={registration}
        translations={translations}
      />
    );
  };
  return ScheduleModalContent;
}
